<template>
  <div class="head">
    <img :src="bgimg" alt class="head-img" />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      bgimg: "../img/head.png"
    };
  },
  beforeCreate() {
    this.$http.get("conf").then(res => {
      this.bgimg = res.body.data.conf[0].value;
    });
  } //生命周期 - 创建之前
};
</script>

<style>
.head {
  width: 100%;
  height: 120px;
}
.head-img {
  width: 100%;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue